import { useSuspenseQuery } from "@tanstack/react-query";

import { fetchWithTimeout } from "@/core/lib/api-client";
import type { UserRead } from "@/openapi";
import { getCurrentUserOptions } from "@/openapi/@tanstack/react-query.gen";

export const useCurrentUser = (): UserRead => {
  return useSuspenseQuery(
    getCurrentUserOptions({ fetch: fetchWithTimeout(5_000) }),
  ).data;
};
